import type { FaireProductEntity } from "../../entity_types/product";

export const p_5yp327uqkx: FaireProductEntity = {
  token: "p_5yp327uqkx",
  type: "product",
  name: "Green Christmas Bow Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/a89a737a8924df2d4e8c6ce8df567c94ff4078b1b78c3d7bbfcd82fbd8b96c19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e30e23a256912fb19f70fa8cc051df047191e79eb7b0913b07355561cd786d41.jpeg",
    "https://cdn.faire.com/fastly/60e2e4bce8f3546da7884f5e4df160b41a1a3e5da27ef2d09e62bc2620a73df8.jpeg"
  ],
  priceDollars: 14,
  description: "Green Christmas Bow Beaded Statement Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings\n\nGreen Christmas Bow Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings - Fashion Earrings for Her\n\nThese lightweight earrings that you will practically forget you are wearing them.\n\nSize is 2.4 x 2.25 inches.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:07.507Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
